import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type { Posts } from '@studio/types';

export const id = {
  [HTTP_METHODS.GET]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/posts/@id`,
    response: {} as Posts.Get.Post,
    method: HTTP_METHODS.GET,
  },
  [HTTP_METHODS.PATCH]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/posts/@id`,
    request: {} as Posts.Patch.Post,
    params: {} as { id: string },
    method: HTTP_METHODS.PATCH,
  },
  [HTTP_METHODS.DELETE]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/posts/@id`,
    params: {} as { id: string },
    method: HTTP_METHODS.DELETE,
  },
};

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/posts`,
    response: {} as Posts.Get.Post[],
    query: {} as
      | {
          clipId: string;
        }
      | {
          endDate: string;
          startDate: string;
          timeZone: string;
        },
    method: HTTP_METHODS.GET,
  },
  [HTTP_METHODS.POST]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/posts`,
    request: {} as Posts.Post.Post,
    response: {} as Posts.Get.Post,
    method: HTTP_METHODS.POST,
  },
};
